<template>
  <div class="manager_dashboard">
  <user-menu />
  <div class="wrapper">
    <!-- <admin-sidebar-menu v-if="admin" /> -->
    <div class="content-wrapper">
    <div class="container-wrapper center">
    <div class="content-main-wrapper signin-form add_account_form center">
    <div><h3 class="d-inline heading">Edit a {{ getFormTitle }}</h3></div>
    <div class="heading-seperator"></div>
      <form @submit.prevent="onSubmit">
		<div class="row margin-bottom-15">
      <div class="col-12 col-sm-12 p-0">
      <div class="col-6 float-left" style="padding-right: 30px;">
        <div class="col-12 p-0" style="margin-top: 10px;">

          <label
              for="first_name"
              class="col-12">First name : <span class="required">*</span></label>
          <input
              type="first_name"
              name="first_name"
              id="first_name"
              class="col-12 col-sm-12 input-height-35"
              ref="first_name"
              v-validate="{ rules: { required: true, regex: nameRegex() } }"
              v-model="first_name"
              data-vv-as="First name"
              maxlength="180">
          <div v-if="verrors.firstByRule('first_name', 'required')" class="validate-warning-msg">First Name is required</div>
          <div v-if="verrors.firstByRule('first_name', 'regex')" class="validate-warning-msg">First Name should only contain - and _</div>
          <div class="col-12 p-0" style="margin-top: 10px;">
          <label
              for="email"
              class="col-12">Email address :</label>
                    {{ email_addr }}
          </div>


          <div class="col-12 p-0" style="margin-top: 10px;" v-if="assessments.length > 0">
            <label
                for="roles"
                class="col-12">Assign Assessments: </label>
            <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in assessments">
              <div class="chkboxwrapper">
                <input 
                  name="Assessment assigned"
                  :value="option.id" 
                  :id="option.id" 
                  type="checkbox" 
                  v-model="assessmentSelected"
                  >
                <label :for="option.name">{{ option.name }}</label>
              </div>
            </div>
         </div>




        </div>
      </div>


      <div class="col-6 float-left" style="padding-left: 30px;">
        <div class="col-12 p-0" style="margin-top: 10px;">
          <label
              for="last_name"
              class="col-12">Last name : <span class="required">*</span></label>
          <input
              type="last_name"
              name="last_name"
              id="last_name"
              class="col-12 col-sm-12 input-height-35"
              ref="last_name"
              v-validate="{ rules: { required: true, regex: nameRegex() } }"
              v-model="last_name"
              data-vv-as="Last name"
              maxlength="180">
          <div v-if="verrors.firstByRule('last_name', 'required')" class="validate-warning-msg">Last Name is required</div>
          <div v-if="verrors.firstByRule('last_name', 'regex')" class="validate-warning-msg">Last Name should only contain - and _</div>
        </div>

        <div class="col-12 p-0" style="margin-top: 10px;">
          <label
              for="phone_number"
              class="col-12">Phone number :</label>
          <input
              type="phone_number"
              name="phone_number"
              id="phone_number"
              class="col-12 col-sm-12 input-height-35"
              ref="phone_number"
          

              @keyup="adminPhoneValid($event)"
              @blur="adminPhoneValid($event)"
              v-validate="{ rules: { regex: adminPhoneRegex() } }"
              v-model="phone_number"
              data-vv-as="Phone number"
              maxlength="14">
          <div v-if="verrors.has('phone_number')" class="validate-warning-msg">Phone number is invalid</div>
        </div>



        <div class="col-12 p-0" style="margin-top: 10px;" v-if="courses.length > 0">
          <label
              for="courses"
              class="col-12">Assign Courses: </label>
          <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in courses">
            <div class="chkboxwrapper">
              <input 
                name="Course assigned"
                :value="option.id" 
                :id="option.id" 
                type="checkbox" 
                v-model="courseSelected"
                >
              <label :for="option.name">{{ option.name }}</label>
            </div>
          </div>
       </div>



      </div>
      </div>
    </div>






          <div class="submit margin-bottom-15" style="text-align: center;">
          <button type="submit" class="btn btn-info btn-md start-button-blue" >Save Changes</button>
        </div>
      </form>
    </div>
    </div>
    </div>
  </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import { store } from '../../store/store';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  data: function () {
    return {
      first_name: '',
      last_name: '',
      phone_number: '',
      email_addr: '',
      password: '',
      pw_confirm: '',
      accountId: '',
      formType: (this.$route.name == 'updatemanager') ? 'Manager' : 'Mentor',
      menteeAssessment: [],
      assessments: [],
      assessmentSelected: [],
      courses: [],
      courseSelected: [],
    };
  },
  computed: {
    getFormTitle() {
      return (this.$route.name == 'updatemanager') ? 'Manager' : 'Mentor';
    }
  },
  methods: {
  nameRegex: function() {
    return /^[a-zA-Z-_ ']*$/;
  },
  adminPhoneRegex: function() {
    return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  },
  adminPhoneValid: function(event) {
    var phone_val = this.phone_number;
    this.phone_number = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  },
  onSubmit () {
      this.$validator.validateAll().then((result) => {
        if(!result) {
          return;
        }
        this.createMentor();
      })
      .catch(() => {

      });
  },
  createMentor() {
      //make axios call to the API
      axios('/mobile/user-profile/' + this.userId,
        {
            method: 'PATCH',
            data: {
                "first_name": this.first_name,
                "last_name": this.last_name,
                "phone_number": this.phone_number,
                "assessments_assigned": this.assessmentSelected,
                "courses_assigned": this.courseSelected,
                "accountId": this.accountId,
            }
        },
    )
    .then(response => {
        this.flash({ message: response.data.successMsg, variant: 'success' });
        this.navigate('/company-admin-dashboard');
    })
    .catch(error => {
        const fieldErrors =  [{}];
        var errMsgObj = error.response.data.message;
        Object.keys(errMsgObj).map(key => {
            var newFieldErr = {field:key, msg:errMsgObj[key]};
            fieldErrors.push(newFieldErr);
        });
        this.$validator.errors.add(fieldErrors);
    });
  },
  navigate(path) {
    router.push(path);
  },
  },
  components: {
    UserMenu,
    GoBack,
    AdminSidebarMenu
  },
  created: function() {
    if (this.$route.params.account_id) {
      this.accountId = this.$route.params.account_id;
    } else {
      this.accountId = this.$store.state.user_accountid;
    }
    this.userId = this.$route.params.user_id;
    var roles = store.state.roles;
    if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
      this.admin = true;
    }
    var role = 'ROLE_MENTOR';
    if(this.formType == 'Manager') {
      role = 'ROLE_ADMIN';
    }

    axios.get('/desktop/course-lists', {
      params: {
         user_roles: role,
         accountId: this.$store.state.user_accountid
        }
      })
      .then(response =>  {
        this.courses = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });

    axios.get('/desktop/assessment-builder-lists', {
    params: {
       user_roles: role,
       accountId: this.$store.state.user_accountid
      }
    })
    .then(response =>  {
      this.assessments = response.data;
      axios('/user-profile/' + this.userId,
      {
          method: 'POST',
          data: {
            accountId: this.$store.state.user_accountid
          }
      })
      .then(resp => {
          this.assessmentSelected = [];
          this.first_name = resp.data.user.first_name;
          this.last_name = resp.data.user.last_name;
          this.phone_number = resp.data.user.phone_number;
          this.email_addr = resp.data.user.email;
          this.assessmentSelected = resp.data.mentee_assessment;
          this.courseSelected = resp.data.user_courses;          
      })
      .catch(() => {
          this.loading = false;
      })
    })
    .catch(function(error) {
      console.log(error);
    });

  }
}
</script>
<style scoped>
.signin-form input {
  border: 1px solid #ced4da;
}
.content-main-wrapper {
  width: 75%;
  background-color: #FFF;
  padding: 30px;
}
.start-button-blue {
    color: #fff;
    background-color: #29A3E4;
    border: 1px solid #29A3E4;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 130px; 
}

</style>


// WEBPACK FOOTER //
// src/components/manager/edit_mentor.vue